import React from 'react'
import { motion } from 'framer-motion'

const GridDetails = ({ contact, setSelectedContact }) => {
    const closeModal = event => {
        if(event.keyCode === 27 || event.currentTarget === event.target) {
          setSelectedContact(null)
        }
      }
    
      window.addEventListener('keydown', event => closeModal(event))
    
      return (
        <div className={style.overlay}>
          <div className={style.container} onClick={event => closeModal(event)}>
            <motion.div
              //animate={{ scale: [0.7, 1.5, 1] }}
              //exit={{ scale: 0 }}
              className={style.modal}
            >
              <p className={style.title}>
                 {contact.nom} {contact.prénom}
              </p>
              <div className={style.content}>
                <p className="font-medium">Nom:</p>
                <p>{contact.nom}</p>
                <p className="font-medium">Prénom:</p>
                <p>{contact.prénom}</p>
                <p className="font-medium">Adresse:</p>
                <p>{contact.adresse}</p>                
                <p className="font-medium">Location:</p>
                <p>{contact.location}</p>
                <p className="font-medium">Téléphone:</p>
                <p>{contact.téléphon}</p>
                <p className="font-medium">Type:</p>
                <p>{contact.type}</p>
                <p className="font-medium">Email:</p>
                <p>{contact.email}</p>
              </div>
            </motion.div>
          </div>
        </div>
      )
    }
    
    const style = {
      overlay: 'fixed top-0 h-screen w-screen bg-black bg-opacity-10',
      container: 'flex h-screen',
      modal: 'my-auto bg-white rounded-lg shadow-lg px-14 pt-5 pb-10 mx-auto ',
      title: 'text-center mb-5 text-gray-700 font-semibold text-xl',
      content: 'grid grid-cols-2 text-gray-600 gap-x-0'
    }

export default GridDetails